/* NewsEntryEdit Messages
 *
 * This contains all the text for NewsEntryEdit component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  saveSuccess: {
    id: 'app.components.NewsEntryEdit.saveSuccess',
    defaultMessage: 'News entry has been successfully updated.',
  },
  saveFailure: {
    id: 'app.components.NewsEntryEdit.saveFailure',
    defaultMessage: 'Error. The news entry could not be updated.',
  },
  title: {
    id: 'app.components.NewsEntryEdit.title',
    defaultMessage: 'Edit News Entry',
  },
  saveButton: {
    id: 'app.components.NewsEntryEdit.saveButton',
    defaultMessage: 'Save',
  },
  deleteNewsEntrySuccess: {
    id: 'app.components.NewsEntryEdit.deleteNewsEntrySuccess',
    defaultMessage: 'News entry successfully deleted.',
  },
  deleteNewsEntryFailed: {
    id: 'app.components.NewsEntryEdit.deleteNewsEntryFailed',
    defaultMessage: 'Failed to delete news entry.',
  },
  deleteNewsEntryConfirmTitle: {
    id: 'app.components.NewsEntryEdit.deleteNewsEntryConfirmTitle',
    defaultMessage: 'Delete news entry',
  },
  deleteNewsEntryConfirmText: {
    id: 'app.components.NewsEntryEdit.deleteNewsEntryConfirmText',
    defaultMessage: 'Deleting this news entry will permanently remove it.',
  },
  deleteNewsEntryConfirmDelete: {
    id: 'app.components.NewsEntryEdit.deleteNewsEntryConfirmDelete',
    defaultMessage: 'Yes, Delete News Entry',
  },
  deleteNewsEntryConfirmCancel: {
    id: 'app.components.NewsEntryEdit.deleteNewsEntryConfirmCancel',
    defaultMessage: 'No, Keep News Entry',
  },
});
